import React, { Children, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

// import JS files
import { useUserData } from "../../context/UserDataContext";
import MuiTheme from "./MuiTheme";

// import Others files

const MuiModal = ({
  openModal,
  setOpenModal,
  children,
  width,
  isOverflow,
  isNotBackdropClick,
}) => {

  const handleClose = (event, reason) => {
    if (reason == "backdropClick") {
      setOpenModal(false);
    }
  };

  return (
    <>
      <MuiTheme>
        <Modal
          disableRestoreFocus
          sx={{ overflow: "scroll" }}
          disableEscapeKeyDown={false}
          open={openModal}
          onClose={isNotBackdropClick ? handleClose : () => setOpenModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className={isOverflow ? "flex justify-center" : ""}>
            <Box className={`panel-modal-box w-11/12 ${width}`}>{children}</Box>
          </div>
        </Modal>
      </MuiTheme>
    </>
  );
};

export default MuiModal;
